import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  width: 382px;
  margin-bottom: auto;
  height: calc(100vh - 64px - 64px - 32px);
`;

export const Content = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .blood-image {
    position: absolute;
    width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .blood-audio {
    width: 100%;
  }

  .blood-description {
    border: 2px solid #cce6ee;
    padding: 15px;
    color: #8a8a8a;
    min-height: 120px;
  }
`;
